import { useState } from 'react'

import { Info, SearchInputDebounced } from 'ui/components'
import { Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'

import { FilterProps } from './Filter.types'
import { s } from './style'

export const Filter = (props: FilterProps) => {
  const { active, activeValues, onActiveChange, onReset, searchTerm, onSearch } = props
  const [isDirty, setDirty] = useState(false)

  const activeChangeHandler = (active: string | null) => {
    onActiveChange(active)
    setDirty(true)
  }

  const onSearchHandler = (text: string) => {
    onSearch(text)
    setDirty(true)
  }

  const resetFilter = () => {
    setDirty(false)
    onReset()
  }

  return (
    <FilterPanel
      isDirty={isDirty}
      onReset={resetFilter}
      customActions={<SearchInputDebounced onChange={onSearchHandler} value={searchTerm} data-qa="Search" />}
      expanded={false}
    >
      <s.Columns>
        <s.Column>
          <Info label="Status">
            <Select data={activeValues} value={active} onChange={activeChangeHandler} />
          </Info>
        </s.Column>
      </s.Columns>
    </FilterPanel>
  )
}
